export const apps = ($http: HttpApi) => ({
  create: (params: HttpParams['body'] = {}) => $http.$post('/builder/apps', { body: params }),
  get: (appName: string) => $http.$get(`/builder/apps/${appName}`),
  install: (appName: string, runtimeValues = {}) => $http.$post('/builder/app_installations', { body: { app: appName, runtime_values: runtimeValues } }),
  list: () => $http.$get('/builder/apps'),
  uninstall: (appName: string) => $http.$delete(`/builder/app_installations/${appName}`),
});
